import { evrApi } from "@evr/apis";
import { PendingLicencePurchase } from "@evr/types";

import { CacheKeys } from "../cacheKeys";
import { PendingLicencePurchaseEndpoint } from "../endpoints";

export const pendingLicencePurchaseApi = evrApi
  .enhanceEndpoints({ addTagTypes: [CacheKeys.PENDING_LICENCE_PURCHASE] })
  .injectEndpoints({
    endpoints: builder => ({
      redeemPendingLicence: builder.query<PendingLicencePurchase, { pendingLicencePurchaseId: string; hash: string }>({
        query: ({ pendingLicencePurchaseId, hash }) => ({
          url: PendingLicencePurchaseEndpoint,
          method: "GET",
          params: { pendingLicencePurchaseId, hash },
        }),
        providesTags: [CacheKeys.PENDING_LICENCE_PURCHASE],
      }),

      updatePendingLicenceCurrency: builder.mutation<
        void,
        { pendingLicencePurchaseId: string; hash: string; transactionCurrencyCode: string }
      >({
        query: ({ pendingLicencePurchaseId, hash, transactionCurrencyCode }) => ({
          url: PendingLicencePurchaseEndpoint,
          method: "PUT",
          params: { pendingLicencePurchaseId, hash, transactionCurrencyCode },
        }),
        invalidatesTags: [CacheKeys.PENDING_LICENCE_PURCHASE],
      }),
      createPendingLicence: builder.mutation<
        { id: string; hash: string; transactionCurrencyCode: string },
        { currencyCode: string }
      >({
        query: ({ currencyCode }) => ({
          url: `${PendingLicencePurchaseEndpoint}/Create/${currencyCode}`,
          method: "POST",
        }),
        invalidatesTags: [CacheKeys.PENDING_LICENCE_PURCHASE],
      }),
    }),
  });

export const {
  useRedeemPendingLicenceQuery,
  useUpdatePendingLicenceCurrencyMutation,
  useCreatePendingLicenceMutation,
} = pendingLicencePurchaseApi;
